export default __webpack_public_path__ + "static/media/superball_web_dark.83dcd897.png";